import { Box, Button } from '@material-ui/core';
import React from 'react';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';
import { useNotify } from '../../../hooks/useNotify';
import { useGuestFields } from '../../../hooks/useGuestFields';

const GuestActions = ({ createGuest }) => {
    const [guest_fields] = useGuestFields();
    const { showModal } = useModals();
    const { notifyError } = useNotify();

    return (
        <Box
            style={{
                marginTop: '10px',
                display: 'flex',
                gap: '10px'
            }}
        >
            <Button
                fullWidth
                variant="contained"
                className="btn-squared"
                color="secondary"
                onClick={() => {
                    showModal(MODAL_TYPE.CREATE_OR_UPDATE_GUEST, {
                        isAgent: true,
                        guest_fields,
                        handleSubmit: data => {
                            createGuest(
                                data.firstname,
                                data.lastname,
                                data.phone,
                                data.email,
                                data.additional_emails,
                                data.guest_field_info,
                                data.arrival_date,
                                data.departure_date,
                                data.internal_notes,
                                data.notification,
                                data.source_id,
                                // onSuccess
                                () => {
                                    showModal(MODAL_TYPE.NONE);
                                },
                                // onError
                                err => {
                                    notifyError(err);
                                }
                            );
                        }
                    });
                }}
            >
                Register a new guest
            </Button>
            <Button
                fullWidth
                variant="outlined"
                className="btn-squared"
                color="primary"
                onClick={() => {
                    if (typeof window.setGuestTableOpen !== 'undefined') {
                        window.setGuestTableOpen(true);
                    }
                }}
            >
                Show guest list
            </Button>
        </Box>
    );
};

export default GuestActions;
